import consts from "@/consts"
import {getApiProps} from "@/lib/lib";
import range from "lodash/range";
// import {objectComparison} from "@/lib/lib";
const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

let _xRoutesWaypointsIndexCache = {arr: null, map: null}
function getXRoutesWaypointsIndexMap(state) {
    if (_xRoutesWaypointsIndexCache.arr !== state.xRoutesWaypoints) {
        _xRoutesWaypointsIndexCache.map = new Map(state.xRoutesWaypoints.map((u, i) => [u.id, i]))
        _xRoutesWaypointsIndexCache.arr = state.xRoutesWaypoints
    }
    return _xRoutesWaypointsIndexCache.map
}

export default {
    state: {
        xRoutesWaypointsLiteLoad: false,
        xRoutesWaypointsFullLoad: false,
        xRoutesWaypoints: [],
    },
    actions: {
        fetchXRoutesWaypoints/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchXRoutesWaypoints', args, time: Date.now() / 1000})

                const params = getApiProps('xRoutesWaypoints', args)
                delete params.routeId;
                delete params.calculated_route_id;

                this.$api.xroutesWaypoints.getAll(args?.routeId, args?.calculated_route_id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchXRoutesWaypoints', args, inprogress: false})
                    });
            })
        },
        fetchXRoutesWaypointsByCalculatedRouteId({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                const params = getApiProps('xRoutesWaypoints', args)
                delete params.routeId;
                delete params.calculated_route_id;

                this.$api.xroutesWaypoints.getAll(args?.routeId, args?.calculated_route_id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('updateXRoutesWaypoints', response.data)
                            commit('setXRoutesWaypointsLiteLoad', true)
                            commit('setXRoutesWaypointsFullLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchXRoutesWaypointsAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchXRoutesWaypointsAll({dispatch, commit}) {
            new Promise((resolve, reject) => {
                this.$api.xroutesWaypoints.getAll()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('updateXRoutesWaypoints', response.data)
                            commit('setXRoutesWaypointsLiteLoad', true)
                            commit('setXRoutesWaypointsFullLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchXRoutesWaypointsAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchXRoutesWaypointsAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isXRoutesWaypointsLiteLoad) {
                    return resolve(getters.getXRoutesWaypoints.length)
                }
                dispatch('fetchXRoutesWaypoints', {lite: true})
                    .then((data) => {
                        commit('updateXRoutesWaypoints', data)
                        //commit('setXRoutesWaypointsLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchXRoutesWaypointsAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchXRoutesWaypointsAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchXRoutesWaypointsAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchXRoutesWaypointsChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getXRoutesWaypoints.length) {
                        return resolve([])
                    }
                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getXRoutesWaypoints.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchXRoutesWaypoints', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateXRoutesWaypoints', data)
                            })
                            .catch(() => {
                                dispatch('fetchXRoutesWaypoints', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setXRoutesWaypointsFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchXRoutesWaypointsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchXRoutesWaypointsChanged', args, inprogress: false})
                })
        },
        fetchXRoutesWaypointsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isXRoutesWaypointsFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchXRoutesWaypointsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchXRoutesWaypoints', args)
                .then((data) => {
                    commit('updateXRoutesWaypoints', data)
                    return dispatch('fetchXRoutesWaypoints', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterXRoutesWaypoints', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchXRoutesWaypointsChanged', args, inprogress: false})
                });
        },
        fetchXRoutesWaypointsChangedByRoute({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isXRoutesWaypointsFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchXRoutesWaypointsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchXRoutesWaypointsByCalculatedRouteId', args)
                .then((data) => {
                    commit('updateXRoutesWaypoints', data)
                    return dispatch('fetchXRoutesWaypointsByCalculatedRouteId', {routeId: args.routeId, calculated_route_id: args.calculated_route_id, fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterXRoutesWaypoints', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchXRoutesWaypointsChangedByRoute', args, inprogress: false})
                });
        },
        fetchFavoritesXRoutesWaypoints({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchFavoritesXRoutesWaypoints', args, time: Date.now() / 1000})

                dispatch('fetchXRoutesWaypoints', {filter: {favorites: true}})
                    .then((data) => {
                        commit('updateXRoutesWaypoints', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesXRoutesWaypoints', args, inprogress: false})
                    });
            })
        },
        reloadXRoutesWaypointsAll({commit, dispatch}, args) {
            commit('clearXRoutesWaypoints')
            return dispatch('fetchXRoutesWaypointsAllLite', args)
                .then(() => {
                    dispatch('fetchXRoutesWaypointsAllPages', args)
                })
        },

        fetchXRoutesWaypoint({commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }
                const params = getApiProps('xRoutesWaypoints', args)
                delete params.id;
                this.$api.xroutesWaypoints.find(args.id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRoutesWaypoint', response.data)
                            resolve(true)
                        } else {
                            console.error(response);
                            reject(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(false)
                    });
            });
        },

        saveXRoutesWaypoint({dispatch}, xRoutesWaypoint) {
            let fn = (xRoutesWaypoint.id) ? 'updateXRoutesWaypoint' : 'createXRoutesWaypoint'
            return dispatch(fn, xRoutesWaypoint);
        },
        createXRoutesWaypoint({commit}, xRoutesWaypoint) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesWaypoints')
                this.$api.xroutesWaypoints.create({routeId: xRoutesWaypoint.routeId, calculated_route_id: xRoutesWaypoint.calculated_route_id}, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('setXRoutesWaypoints', response.data)
                            //dispatch('fetchXRoutesWaypointsChanged', {routeId: xRoutesWaypoint.routeId, calculated_route_id: xRoutesWaypoint.calculated_route_id})
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateXRoutesWaypoint({commit, dispatch}, xRoutesWaypoint) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesWaypoints')
                this.$api.xroutesWaypoints.update(xRoutesWaypoint.id, xRoutesWaypoint, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRoutesWaypoint', response.data)
                            dispatch('fetchXRoutesWaypointsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        deleteXRoutesWaypoint({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesWaypoints')
                this.$api.xroutesWaypoints.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteXRoutesWaypoint', id)
                            else commit('updateXRoutesWaypoint', response.data)
                            dispatch('fetchXRoutesWaypointsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        restoreXRoutesWaypoint({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesWaypoints')
                this.$api.xroutesWaypoints.restore(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRoutesWaypoint', response.data)
                            dispatch('fetchXRoutesWaypointsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteXRoutesWaypointPermanently({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesWaypoints')
                this.$api.xroutesWaypoints.deletePermanently(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteXRoutesWaypoint', id)
                            dispatch('fetchXRoutesWaypointsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        //sayHello() {}
    },
    mutations: {
        setXRoutesWaypointsLiteLoad(state, LiteLoad) {
            state.xRoutesWaypointsLiteLoad = state.xRoutesWaypointsLiteLoad || LiteLoad
        },
        setXRoutesWaypointsFullLoad(state, FullLoad) {
            state.xRoutesWaypointsFullLoad = state.xRoutesWaypointsFullLoad || FullLoad
        },

        setXRoutesWaypoints(state, nXRoutesWaypoints) {
            nXRoutesWaypoints = nXRoutesWaypoints.map(u => {
                //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return Object.freeze(u)
            })
            nXRoutesWaypoints.sort(sortByName)
            state.xRoutesWaypoints = nXRoutesWaypoints
        },

        updateXRoutesWaypoints(state, nXRoutesWaypoints) {
            if (!state.xRoutesWaypoints.length) {
                nXRoutesWaypoints = nXRoutesWaypoints.map(u => {
                    //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return Object.freeze(u)
                })
                nXRoutesWaypoints.sort(sortByName)
                state.xRoutesWaypoints = nXRoutesWaypoints
                return true
            }

            // console.log('updateXRoutesWaypoints', state.xRoutesWaypoints.length)
            const indexById = getXRoutesWaypointsIndexMap(state)
            nXRoutesWaypoints.forEach(function (nXRoutesWaypoint) {
                let i = indexById.has(nXRoutesWaypoint.id) ? indexById.get(nXRoutesWaypoint.id) : -1
                if (i < 0) {
                    indexById.set(nXRoutesWaypoint.id, state.xRoutesWaypoints.length)
                    state.xRoutesWaypoints.push(Object.freeze(nXRoutesWaypoint))
                } else
                if (state.xRoutesWaypoints[i][changedField] != nXRoutesWaypoint[changedField]) {
                    // updateObjectByDiff(state.xRoutesWaypoints[i], nXRoutesWaypoint)
                    delete nXRoutesWaypoint.id
                    state.xRoutesWaypoints[i] = Object.freeze({...state.xRoutesWaypoints[i], ...nXRoutesWaypoint})
                }
            })
        },
        filterXRoutesWaypoints(state, nXRoutesWaypoints) {
            // let Ids = state.xRoutesWaypoints.map(u=> u.id)
            let nIds = new Set(nXRoutesWaypoints.map(u => u.id))
            state.xRoutesWaypoints = state.xRoutesWaypoints.filter(u => nIds.has(u.id))
        },
        updateXRoutesWaypoint(state, nXRoutesWaypoint) {
            let i = state.xRoutesWaypoints.findIndex(u => (u.id == nXRoutesWaypoint.id))
            if (i < 0) {
                state.xRoutesWaypoints.push(Object.freeze(nXRoutesWaypoint))
            } else
            if (!state.xRoutesWaypoints[i][changedField] != nXRoutesWaypoint[changedField]) {
                // updateObjectByDiff(state.xRoutesWaypoints[i], nXRoutesWaypoint)
                let xRoutesWaypoint = {...nXRoutesWaypoint} //ToDo fix
                delete xRoutesWaypoint.id
                state.xRoutesWaypoints[i] = Object.freeze({...state.xRoutesWaypoints[i], ...xRoutesWaypoint})
            }
        },
        deleteXRoutesWaypoint(state, id) {
            let i = state.xRoutesWaypoints.findIndex(u => (u.id == id))
            if (i != -1) {
                state.xRoutesWaypoints.splice(i, 1)
            }
        },
        clearXRoutesWaypoints(state) {
            state.xRoutesWaypoints = []
            state.xRoutesWaypointsLiteLoad = false
            state.xRoutesWaypointsFullLoad = false
        },
    },
    getters: {
        isXRoutesWaypointsLiteLoad(state) {
            return state.xRoutesWaypointsLiteLoad
        },
        isXRoutesWaypointsFullLoad(state) {
            return state.xRoutesWaypointsFullLoad
        },
        getXRoutesWaypoints(state) {
            return state.xRoutesWaypoints
        },
        getXRoutesWaypointsByIds(state) {
            return state.xRoutesWaypoints.reduce((xRoutesWaypointsByIds, u) => {
                xRoutesWaypointsByIds[u.id] = u
                return xRoutesWaypointsByIds
            }, {})
        },
    }
}
